import { render, staticRenderFns } from "./IconSVG.vue?vue&type=template&id=3b60f344&scoped=true&"
import script from "./IconSVG.vue?vue&type=script&lang=js&"
export * from "./IconSVG.vue?vue&type=script&lang=js&"
import style0 from "./IconSVG.vue?vue&type=style&index=0&id=3b60f344&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b60f344",
  null
  
)

export default component.exports